export default __webpack_public_path__ + "static/media/custom_fields_intro.49424623.svg";